import { useMemo } from 'react'

import { ColorSelector as LMFColorSelector, Warning } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../../../app/_providers/TranslationProvider.client'
import { EmbroideryService } from '../../../../../containers/EmbroideryService'
import { isSufficientEmbroideryColorContrast } from '../../../../../containers/EmbroideryService/utils/unorganized'
import { ProductColor } from '../../../../../types/graphql'
import { ErrorMessage, Label, SelectedOptionText, WarningMessage } from '../../shared-form-styles'

export enum TextEmbroideryColorEnum {
  Black = 'Black',
  White = 'White',
}

export const TEXT_EMBROIDERY_COLOR_VALUES = [
  TextEmbroideryColorEnum.Black,
  TextEmbroideryColorEnum.White,
]

export type TextEmbroideryColorKey = (typeof TEXT_EMBROIDERY_COLOR_VALUES)[number]

export const isTextEmbroideryColorKey = (value: unknown): value is TextEmbroideryColorKey => {
  return TEXT_EMBROIDERY_COLOR_VALUES.includes(value as TextEmbroideryColorKey)
}

export const colorMap: Record<TextEmbroideryColorKey, ProductColor> = {
  Black: {
    hexCodes: ['000'],
    availability: '',
    handle: 'black',
    name: 'Black',
    rawName: 'Black',
  },
  White: {
    hexCodes: ['fff'],
    availability: '',
    handle: 'white',
    name: 'White',
    rawName: 'White',
  },
}

export const ColorSelector: React.FC<{
  disabled?: boolean
  errorMessage?: string
  onSelectColor(colorName: string): void
  selectedColorKey: TextEmbroideryColorKey | undefined
  label: string
  colorNames: TextEmbroideryColorKey[]
}> = ({ disabled, errorMessage, onSelectColor, selectedColorKey, label, colorNames }) => {
  const strings = useTranslation()
  const colors = useMemo(
    () => colorNames.filter(name => colorMap[name]).map(name => colorMap[name]!),
    [colorNames]
  )
  const { productColorHex } = EmbroideryService.useContainer()

  const isSufficientColorContrast = selectedColorKey
    ? isSufficientEmbroideryColorContrast(
        productColorHex,
        '#' + colorMap[selectedColorKey].hexCodes[0]
      )
    : undefined

  const warningMessage = isSufficientColorContrast
    ? null
    : strings.embroidery.validation.colorContrastWarning
  return (
    <>
      <Label disabled={disabled ?? false}>
        {label}{' '}
        <SelectedOptionText disabled={disabled ?? false}>{selectedColorKey}</SelectedOptionText>
      </Label>

      <LMFColorSelector
        colors={colors}
        disabled={disabled ?? false}
        onSelectColor={color => onSelectColor(color.name)}
        selectedColorKey={selectedColorKey}
      />

      {errorMessage ? (
        <ErrorMessage role='alert'>{errorMessage}</ErrorMessage>
      ) : warningMessage ? (
        <WarningMessage role='alert'>
          <Warning height={'13px'} width={'13px'} fill={'currentcolor'} />
          {warningMessage}
        </WarningMessage>
      ) : null}
    </>
  )
}
